document.addEventListener('DOMContentLoaded', () => {
  function animateNumber(el, end, duration=2000) {
    let startTimestamp = null;
    const start = 0;
    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      el.innerText = Math.floor(progress * (end - start) + start);
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        let parentEl = entry.target;

        // 数字从 0 --> Max 动效 
        parentEl?.querySelectorAll(".item-title span")?.forEach(el => {
          animateNumber(el, parseInt(el.dataset.target), parseInt(el.dataset.duration));
        });

        // 视频播放一次 
        let video = parentEl?.querySelector(".video-box video");
        if(video) {
          setTimeout(() => {video.play();}, 200);
          video.addEventListener("ended", () => {
            video.pause();
          }, { once: true });  // 只执行一次;
        }

        observer.unobserve(parentEl); // 只执行一次
      }
    });
  }, { threshold: 0.5 }); // 元素有 50% 出现在视口时触发;

  $('.ht-battery-animation').each(function() {
    observer.observe(this);
  });
})